module.exports = __webpack_public_path__ + "assets/img/mc2.a2970495.jpg";